/**
 * Persönliche Empfehlung — dieselbe Darstellung auf Event-, Raid- und
 * Pokémon-Seiten, damit die Aussage überall gleich gelesen wird.
 */

export const EMPFEHLUNG = {
  must:    { label: 'Lohnt sich', farbe: 'var(--verdict-strong)', zeichen: '★' },
  nice:    { label: 'Kann man mitnehmen', farbe: 'var(--verdict-solid)', zeichen: '•' },
  skip:    { label: 'Kannst du auslassen', farbe: 'var(--verdict-collection)', zeichen: '–' },
  unknown: { label: 'Unklar', farbe: 'var(--verdict-unrated)', zeichen: '?' },
};

export function EmpfehlungsBadge({ personal }) {
  if (!personal) return null;
  const e = EMPFEHLUNG[personal.level] ?? EMPFEHLUNG.unknown;

  return (
    <span className="badge" style={{ '--badge-color': e.farbe }} title={personal.reason}>
      {e.zeichen} {e.label}
    </span>
  );
}

/** Ausführliche Variante mit Begründung — für Detailseiten. */
export function EmpfehlungsKasten({ personal }) {
  if (!personal) return null;
  const e = EMPFEHLUNG[personal.level] ?? EMPFEHLUNG.unknown;

  return (
    <div className="empfehlung" style={{ '--empf-farbe': e.farbe }}>
      <div className="empfehlung__kopf">
        <span className="empfehlung__zeichen">{e.zeichen}</span>
        <strong>{personal.title}</strong>
      </div>
      <p className="empfehlung__grund">{personal.reason}</p>
      {personal.owned && (
        <p className="empfehlung__besitz">
          In deiner Sammlung: {personal.owned.count}
          {personal.owned.count === 1 ? ' Exemplar' : ' Exemplare'}
          {personal.owned.bestIv !== null && `, bestes ${personal.owned.bestIv}%`}
          {personal.owned.bestCp > 0 && ` mit ${personal.owned.bestCp} WP`}
          {personal.owned.viaBase && ' (Grundform)'}
        </p>
      )}
    </div>
  );
}

/** Zusammenfassung über ein ganzes Event. */
export function EmpfehlungsZusammenfassung({ summary }) {
  if (!summary) return null;

  const text = summary.must > 0
    ? `${summary.must} ${summary.must === 1 ? 'Pokémon lohnt' : 'Pokémon lohnen'} sich für dich`
    : summary.nice > 0
      ? 'Nichts Dringendes, aber ein paar Mitnahmen'
      : 'Für dich vermutlich verzichtbar';

  const farbe = summary.must > 0
    ? 'var(--verdict-strong)'
    : summary.nice > 0 ? 'var(--verdict-solid)' : 'var(--verdict-collection)';

  return <span className="badge" style={{ '--badge-color': farbe }}>{text}</span>;
}
